module.exports = __webpack_public_path__ + "img/2.4ece6541.png";